export const prepareDamagesDescription = damages => {
  if (!damages || damages.length === 0) {
    return null;
  }
  if (damages.length === 1) {
    return 'damage';
  }
  return 'damages';
};
